export default "__VITE_ASSET__M1_BRGUc__"